import { render, staticRenderFns } from "./businesslist.vue?vue&type=template&id=4b87828e"
import script from "./businesslist.vue?vue&type=script&lang=js"
export * from "./businesslist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports